import React from "react";
import Image from "next/image";
import * as cx from "classnames/bind";
import e from "styles/Carousel.module.scss";

export const Thumb = ({ selected, onClick, imgSrc }) => (
  <div
    className={cx(
      e.embla__slide,
      e.embla__slide__thumb,
      selected ? e.is_selected : "",
    )}
  >
    <button
      onClick={onClick}
      className={cx(e.embla__slide__inner, e.embla__slide__inner__thumb)}
      type="button"
    >
      <Image
        className={cx(e.embla__slide__thumbnail)}
        width={200}
        height={200}
        src={imgSrc}
        alt="A cool cat."
      />
    </button>
  </div>
);
